var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0762 7.81409C18.665 8.88477 19 10.1148 19 11.423C19 15.5651 15.6421 18.923 11.5 18.923C7.35786 18.923 4 15.5651 4 11.423C4 10.0713 4.35756 8.80318 4.98326 7.70797C4.83696 6.51294 3.76577 6.66339 3.12 6.94404C2.4053 8.27843 2 9.80338 2 11.423C2 16.6697 6.25329 20.923 11.5 20.923C16.7467 20.923 21 16.6697 21 11.423C21 9.81272 20.5994 8.29602 19.8923 6.96713C18.8961 6.69138 18.3116 7.32737 18.0762 7.81409Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 2,
    height: 9,
    rx: 1,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.99b6669eb2eb5d0143af4c488e4e94bf.svg";
export { ForwardRef as ReactComponent };